module.exports = __webpack_public_path__ + "2124f52425b7442a5b683a47f2570fb1.pdf";